import { useEffect, useRef } from 'react';

export const useSameWidthAsPreviousElement = () => {
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const updateWidth = () => {
      const previousElement = elementRef.current?.previousElementSibling as HTMLDivElement;
      if (previousElement && elementRef.current) {
        const previousElementWidth = previousElement.offsetWidth;
        elementRef.current.style.width = `${previousElementWidth}px`;
      }
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, []);

  return [elementRef];
}